module.exports = __webpack_public_path__ + "static/media/arrow-up.191c8000.svg";